import { Users, Building2, CalendarCheck, ImageOff } from 'lucide-react';
import { useAdminOverview } from 'app/javascript/queries/useAdmin';
import { Skeleton } from 'app/javascript/components/ui/skeleton';
import StatCard from 'app/javascript/components/admin/StatCard';
import JobsHealthCard from 'app/javascript/components/admin/JobsHealthCard';

export default function OverviewCards() {
  const { data, isLoading, isError } = useAdminOverview();

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-24 rounded-xl" />
        ))}
      </div>
    );
  }

  if (isError || !data) {
    return (
      <p className="text-sm text-red-400">
        Não foi possível carregar o overview. Tente novamente mais tarde.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <StatCard
          icon={<Users className="h-4 w-4" />}
          label="Usuários"
          value={data.users_total}
          sublabel={`+${data.users_last_7_days} nos últimos 7 dias`}
        />
        <StatCard
          icon={<Building2 className="h-4 w-4" />}
          label="Academias"
          value={data.companies_total}
          sublabel={`+${data.companies_last_7_days} nos últimos 7 dias`}
        />
        <StatCard
          icon={<CalendarCheck className="h-4 w-4" />}
          label="Check-ins hoje"
          value={data.check_ins_today}
        />
        <StatCard
          icon={<ImageOff className="h-4 w-4" />}
          label="Fotos com problema"
          value={data.failed_photos_last_7_days + data.stuck_photos}
          sublabel={`${data.failed_photos_last_7_days} falhadas (7d) · ${data.stuck_photos} ${
            data.stuck_photos === 1 ? 'travada' : 'travadas'
          }`}
        />
      </div>
      <JobsHealthCard jobs={data.jobs} />
    </div>
  );
}
